import moment from 'moment';
import React, {
  CSSProperties,
  FunctionComponent,
  useEffect,
  useState,
} from 'react';
import {INotificationGet, NotificationTargeting} from '../../types/notifications';
import {SubMenu} from '../SubMenu';
import {NotificationEditorContent} from './components/NotificationEditorContent';
import {NotificationEditorMetaData} from './components/NotificationEditorMetaData';
import {NotificationEditorTargeting} from './components/NotificationEditorTargeting';

export type NotificationEditorProps = {
  onChange: (key: string, value: any) => void;
  data: INotificationGet;
  setErrorForSubmit?: (hasError: boolean) => void;
  isCreation?: boolean;
  appRoutesToRedirect?: Record<string, {screenName: string; path: string}>;
  calculateBlogPostTargeting: (payload: NotificationTargeting, onSuccess?: ((response: {
    recentlyConnectedCount: number;
    totalCount: number;
  }) => void) | undefined) => (_dispatch: any, getState: any) => Promise<void>;
};

export type NotificationEditorContentProps = {
  onChange: (key: string, value: any) => void;
  data: INotificationGet;
  selectedDateToggle: boolean;
  setSelectedDateToggle: React.Dispatch<React.SetStateAction<boolean>>;
  setErrorForSubmit?: (hasError: boolean) => void;
  isCreation?: boolean;
  appRoutesToRedirect?: Record<string, {screenName: string; path: string}>;
  calculateBlogPostTargeting: (payload: NotificationTargeting, onSuccess?: ((response: {
    recentlyConnectedCount: number;
    totalCount: number;
  }) => void) | undefined) => (_dispatch: any, getState: any) => Promise<void>;
};

const styles: Record<string, CSSProperties> = {
  container: {
    marginTop: 16,
  },
  content: {
    paddingLeft: 8,
    paddingRight: 8,
    paddingTop: 16,
    paddingBottom: 16,
    width: '100%',
    backgroundColor: 'white',
  },
};

export const NotificationEditor: FunctionComponent<NotificationEditorProps> = ({
  data,
  onChange,
  isCreation,
  setErrorForSubmit,
  appRoutesToRedirect,
  calculateBlogPostTargeting,
}) => {
  const [selectedTabs, setSelectedTabs] = useState(0);
  const [selectedDateToggle, setSelectedDateToggle] = useState<boolean>(false);
  const onChangeMenuIndex = (index: number) => setSelectedTabs(index);

  const tabs = [
    {
      label: 'Metas données',
      isRequired: true,
      ContentComponent: NotificationEditorMetaData,
    },
    {
      label: 'Contenu notif',
      isRequired: !isCreation,
      ContentComponent: NotificationEditorContent,
    },
    {
      label: 'Targeting',
      isRequired: !isCreation,
      ContentComponent: NotificationEditorTargeting,
    },
  ];
  
  const ContentComponent = tabs[selectedTabs].ContentComponent;
  
  useEffect(() => {
    if (
      data.scheduledDate &&
      !moment(data.scheduledDate).isSameOrBefore(moment())
    ) {
      setSelectedDateToggle(true);
    }
  }, []);

  return (
    <div style={styles.container}>
      <SubMenu
        tabs={tabs}
        selectedTabs={selectedTabs}
        onChange={onChangeMenuIndex}
      />
      <div style={styles.content}>
        <ContentComponent
          selectedDateToggle={selectedDateToggle}
          setSelectedDateToggle={setSelectedDateToggle}
          data={data}
          onChange={onChange}
          isCreation={isCreation}
          setErrorForSubmit={setErrorForSubmit}
          appRoutesToRedirect={appRoutesToRedirect}
          calculateBlogPostTargeting={calculateBlogPostTargeting}
        />
      </div>
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/components/NotificationEditor/index.tsx